/**
 * Account Management Header Component
 *
 * Displays page title, description, and action buttons (CSV, Add Account).
 */

import React from 'react';
import { Plus } from 'lucide-react';
import { Button } from '@/shared/ui/components/Button';
import { CsvImportButton, CsvExportButton } from '@/features/account-csv';
import type { CsvImportState, CsvExportState } from '@/features/account-csv';

interface AccountHeaderProps {
  onAddClick: () => void;
  csvImportState: CsvImportState;
  csvExportState: CsvExportState;
}

export const AccountHeader: React.FC<AccountHeaderProps> = ({
  onAddClick,
  csvImportState,
  csvExportState,
}) => {
  return (
    <div className="flex flex-wrap justify-between items-center gap-4">
      <div>
        <h2 className="text-xl font-semibold flex items-center">SNS 계정 관리</h2>
        <p className="text-gray-500 text-sm mt-1">소셜미디어 계정을 통합 관리합니다</p>
      </div>

      <div className="flex space-x-3">
        <CsvImportButton state={csvImportState} />
        <CsvExportButton state={csvExportState} />
        <Button size="sm" onClick={onAddClick}>
          <Plus className="w-4 h-4 mr-1" /> 계정 추가
        </Button>
      </div>
    </div>
  );
};

AccountHeader.displayName = 'AccountHeader';
